<!--
  @Description 项目进度主界面
  @Date 2022-01-06
  @Author liushuo
  1.测试可填写条件：项目状态为[开发完成、待测试、测试中、测试完成]
  2.研发可填写条件：项目状态为[待开发、开发中、开发完成]
  3.本人方可填写本人的进度，特殊权限则均可填写
  4.[开发完成]状态的数据等于[待测试]状态的数据
-->
<template>
  <div class="container">
    <homeHeader
      ref="HomeHeader"
      title="项目进度"
      :isShowProjectSelect="true"
      @changeSelect="changeSelect"
      key="schedule"
    ></homeHeader>
    <div class="main">
      <div class="card">
        <!-- 按钮组 -->
        <div class="toolbar-dv">
          <toolBarBtn
            :buttonVisible="buttonVisible"
            :parentData="this"
            ref="toolBarBtn"
            :moreButtonList="moreButtonList"
          ></toolBarBtn>
        </div>

        <!-- 基础设置功能区 -->
        <div class="settings-table-dv">
          <el-row :gutter="20">
            <el-col :span="4">
              <!-- 列表 -->
              <div class="left-settings-dv" :style="{ height: this.settingsCardHeight }">
                <div class="settings-list-dv" :style="{ height: this.leftTableHeight }">
                  <navList
                    ref="navList"
                    :listData="settingsList"
                    title="产品版本"
                    :listKey="'name'"
                    indexKey="name"
                    :indexValue="indexValue"
                    @itemClick="changeNavItem"
                  ></navList>
                </div>
              </div>
            </el-col>
            <el-col :span="20">
              <!-- 明细表格 -->
              <div class="right-user-dv" :style="{ height: this.settingsCardHeight }">
                <el-tabs v-model="tabActiveName">
                  <el-tab-pane label="进度" name="first">
                    <vxe-grid
                      ref="xTable"
                      resizable
                      :data="tableDataSchedule"
                      size="mini"
                      :mouse-config="{ area: true }"
                      highlight-hover-row
                      highlight-current-row
                      :height="tableHeight"
                      :columns="gridColumns"
                      :cell-style="tableCellStyle"
                      :row-config="{ height: 60 }"
                      :showOverflow="true"
                      :tooltip-config="{
                        showAll: true,
                        theme: 'dark'
                      }"
                      :keyboard-config="{
                        isArrow: true,
                        isEnter: true,
                        isTab: true,
                        isClip: true,
                        enterToTab: true,
                        isEdit: true
                      }"
                      @menu-click="contextMenuClickEvent"
                      :menu-config="{
                        body: { options: bodyMenus },
                        visibleMethod
                      }"
                      :sort-config="{
                        trigger: 'cell',
                        orders: ['desc', 'asc', null]
                      }"
                    >
                    </vxe-grid>
                  </el-tab-pane>

                  <el-tab-pane label="看板" name="second">
                    <div class="second-dv" :style="{ height: secondDvHeight }">
                      <Dashboard
                        :data="this.listData.unCode"
                        key="unCode"
                        title="待开发"
                        titleClass="danger"
                        type="研发"
                        icon="el-icon-alarm-clock"
                      ></Dashboard>
                      <Dashboard
                        :data="this.listData.coding"
                        key="coding"
                        title="开发中"
                        titleClass="normal"
                        type="研发"
                        icon="el-icon-s-order"
                      ></Dashboard>
                      <Dashboard
                        :data="this.listData.codeFinish"
                        key="codeFinish"
                        title="开发完成"
                        titleClass="success"
                        type="研发"
                        icon="el-icon-s-claim"
                      ></Dashboard>
                      <!-- <Dashboard
                    :data="this.listData.unTest"
                    key="unTest"
                    title="待测试"
                    titleClass="danger"
                    type="测试"
                    icon="el-icon-alarm-clock"
                  ></Dashboard> -->
                      <Dashboard
                        :data="this.listData.testing"
                        key="testing"
                        title="测试中"
                        titleClass="normal"
                        type="测试"
                        icon="el-icon-s-order"
                      ></Dashboard>
                      <Dashboard
                        :data="this.listData.testFinish"
                        key="testFinish"
                        titleClass="success"
                        title="测试完成"
                        type="测试"
                        icon="el-icon-s-claim"
                      ></Dashboard>
                    </div>
                  </el-tab-pane>

                  <el-tab-pane label="统计" name="third">
                    <div class="third-dv" :style="{ height: secondDvHeight }">
                      <!-- 左侧图表 -->
                      <div class="third-left-dv">
                        <!-- 饼图 -->
                        <div class="pie-dv">
                          <div>
                            <PieLeft key="pieLeft" ref="pieLeft"></PieLeft>
                          </div>
                          <div>
                            <PieRight key="pieRight" ref="pieRight"></PieRight>
                          </div>
                        </div>
                        <div class="line-dv">
                          <LineChart key="lineChart" ref="lineChart"></LineChart>
                        </div>
                      </div>

                      <!-- 右侧表格 -->
                      <div class="third-right-dv">
                        <!-- 按人员汇总 -->
                        <vxe-grid
                          ref="xTableByPerson"
                          resizable
                          :data="tableDataByPerson"
                          size="mini"
                          :mouse-config="{ area: true }"
                          highlight-hover-row
                          highlight-current-row
                          :height="tableHeightByPerson"
                          :columns="gridColumnsByPerson"
                          :cell-style="tableCellStyle"
                          :row-config="{ height: 60 }"
                          :showOverflow="true"
                          :tooltip-config="{
                            showAll: true,
                            theme: 'dark'
                          }"
                          :keyboard-config="{
                            isArrow: true,
                            isEnter: true,
                            isTab: true,
                            isClip: true,
                            enterToTab: true,
                            isEdit: true
                          }"
                          :sort-config="{
                            trigger: 'cell',
                            orders: ['desc', 'asc', null]
                          }"
                        >
                        </vxe-grid>
                      </div>
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <!-- 导入 -->
    <Import ref="Import" @sureImportBack="sureImportBack"></Import>
    <!-- 工作量评估弹窗 -->
    <ScheduleSet ref="ScheduleSet"></ScheduleSet>
    <!-- 员工档案 -->
    <EmployeeSelect
      ref="EmployeeSelect"
      :isMultiple="false"
      :sqlTitle="personSqlTitle"
      @sureBackPerson="sureBackPerson"
      :isRequired="true"
    />
  </div>
</template>

<script>
import Import from './import'
import ScheduleSet from './scheduleSet'
import Dashboard from './dashboard'
import PieLeft from './pieLeft'
import PieRight from './pieRight'
import LineChart from './line'

export default {
  components: {
    Import,
    ScheduleSet,
    Dashboard,
    PieLeft,
    PieRight,
    LineChart
  },
  data() {
    return {
      searchFormVisible: false,
      // 正常状态下，需要加上表格距离card上下的margin
      topBottomMargin: 20,
      // 按钮组的可见性
      buttonVisible: {
        update: false,
        add: false, // 新增按钮是否显示
        save: false, // 保存按钮是否显示
        delete: false,
        refresh: true,
        sort: false, // 排序按钮是否显示
        search: false, // 查找按钮是否显示
        more: false // 更多按钮是否显示
      },
      // 获取权限
      Authority: this.AuthorityFilter(this.$route.path),
      // 特殊权限
      specialAuthority: {},
      // 左侧列表数据
      settingsList: [],
      // tab当前激活位置
      tabActiveName: 'first',
      // 列
      gridColumns: [],
      gridColumnsByPerson: [],
      // 人员选择框过滤条件
      personSqlTitle: '',
      // 当前点击列名
      curSelectCol: '',
      // 进度表数据
      tableDataSchedule: [],
      // 汇总表数据
      tableDataByPerson: [],
      // 拉选区域
      areas: [],
      // 按钮组扩展按钮 { icon: xxx, name: xxx, event: xxx, visible: xxx }
      moreButtonList: [],
      // 产品类型下拉框值
      optionsValue: '',
      // 侧边栏默认选中的值
      curSelectVersion: '',
      // 用于人员选择框过滤用的字典
      perSqlTitleMap: {
        frontEngineer: '前端研发',
        backEngineer: '后端研发',
        techTester: '技术测试',
        businessTester: '业务测试'
      },
      // 不同状态的数据（待开发、开发中、开发完成、待测试、测试中、测试完成）
      listData: {
        unCode: [],
        coding: [],
        codeFinish: [],
        // unTest: [],
        testing: [],
        testFinish: []
      },
      // 人员岗位类型常量
      PERSONTYPE: {
        // [前端进度]：[前端研发]
        frontWorkPercentage: '前端研发',
        // [后端进度]：[后端研发]
        backWorkPercentage: '后端研发',
        // [技术测试进度]：[技术测试]
        techTestPercentage: '技术测试',
        // [业务测试进度]：[业务测试]
        businessTestPercentage: '业务测试'
      },
      // 右键菜单
      bodyMenus: [
        [
          {
            code: 'schedule',
            name: '填写进度'
          },
          {
            code: 'choosePerson',
            name: '选择人员'
          },
          {
            code: 'batchDelete',
            name: '批量删除'
          }
        ]
      ],
      // 选中tab
      indexValue: '',

      // 图表数据 - 开发进度
      devPieData: {},
      // 图表数据 - 测试进度
      testPieData: {},
      // 柱状图数据 - 人员
      nameData: [],
      // 柱状图数据 - 有效值
      valueData: [],
      // 柱状图数据 - 总值
      backData: []
    }
  },
  created() {
    this.getSpecial()
    this.InitColumns()
  },
  async activated() {
    this.initButtons()
    // 需要等版本获取到后，才能获取当前数据
    this.$nextTick(() => {
      this.getNavList()
    })
    // this.getList()
  },
  methods: {
    // 获取特殊权限，格式如：specialAuthority:{ '权限名称':true }
    getSpecial() {
      this.Authority.special.forEach(v => {
        this.specialAuthority[v.name] = true
      })
    },
    // 设置列
    InitColumns() {
      this.gridColumns = [
        { type: 'seq', width: 50, fixed: 'left' },
        {
          field: 'delete',
          title: '删除',
          fixed: 'left',
          visible: !!this.specialAuthority.super,
          width: '50',
          align: 'center',
          slots: {
            default: ({ row }) => {
              return [
                <i
                  id='vxeDelete'
                  class='el-icon-delete-solid'
                  onClick={() => {
                    this.removeRowForTable(row, this.$refs.xTable, this.$data)
                  }}
                ></i>
              ]
            }
          }
        },
        {
          title: '模块',
          width: 150,
          fixed: 'left',
          field: 'groupName',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '页面',
          minWidth: 120,
          fixed: 'left',
          field: 'vuePath',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '类型',
          width: 80,
          fixed: 'left',
          field: 'type',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '项目状态',
          width: 120,
          fixed: 'left',
          field: 'caseStatus',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '前端研发',
          width: 100,
          field: 'frontEngineer',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' },
          slots: {
            default: ({ row }) => {
              if (!row.frontEngineer || row.frontEngineer === '/') {
                return [<span> / </span>]
              } else {
                return [<span>{row.frontEngineer}</span>]
              }
            }
          }
        },
        {
          title: '前端进度',
          width: 100,
          field: 'frontWorkPercentage',
          slots: {
            default: ({ row, column }) => {
              if (!row.frontEngineer || row.frontEngineer === '/') {
                return [<span> / </span>]
              } else {
                return this.formatSchedule(row, column)
              }
            }
          },
          sortable: true
        },
        {
          title: '后端研发',
          width: 100,
          field: 'backEngineer',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' },
          slots: {
            default: ({ row }) => {
              if (!row.backEngineer || row.backEngineer === '/') {
                return [<span> / </span>]
              } else {
                return [<span>{row.backEngineer}</span>]
              }
            }
          }
        },
        {
          title: '后端进度',
          width: 100,
          field: 'backWorkPercentage',
          slots: {
            default: ({ row, column }) => {
              if (!row.backEngineer || row.backEngineer === '/') {
                return [<span> / </span>]
              } else {
                return this.formatSchedule(row, column)
              }
            }
          },
          sortable: true
        },
        {
          title: '技术测试',
          width: 100,
          field: 'techTester',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '技术测试进度',
          width: 120,
          field: 'techTestPercentage',
          slots: {
            default: ({ row, column }) => {
              return this.formatSchedule(row, column)
            }
          },
          sortable: true
        },
        {
          title: '业务测试',
          width: 100,
          field: 'businessTester',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '业务测试进度',
          width: 120,
          field: 'businessTestPercentage',
          slots: {
            default: ({ row, column }) => {
              return this.formatSchedule(row, column)
            }
          },
          sortable: true
        }
      ]
      this.gridColumnsByPerson = [
        { type: 'seq', width: 40, fixed: 'left' },
        {
          title: '人员',
          width: 120,
          field: 'name',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '任务总量',
          field: 'sum',
          sortable: true
        },
        {
          title: '待完成',
          field: 'todo',
          sortable: true
        },
        {
          title: '完成中',
          field: 'ing',
          sortable: true
        },
        {
          title: '已完成',
          field: 'completed',
          sortable: true
        },
        {
          title: '完成率',
          field: 'rate'
        }
      ]
    },
    // 根据产品类型、产品版本进行数据获取
    async getList() {
      const { data: res } = await this.$http.post(`/Common/YKProjectSchedule/list`, {
        menuArgs: this.curProductType,
        productVersion: this.curSelectVersion
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
      }
      this.tableDataSchedule = res.data.rows
      // 对不同状态的数据进行分类
      this.setDiffData(res.data.rows)
    },
    // 获取统计tab数据
    async getStatisticList() {
      const { data: res } = await this.$http.post(`/Common/YKProjectSchedule/statistics`, {
        menuArgs: this.curProductType,
        productionVersion: this.curSelectVersion
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
      }
      this.tableDataByPerson = res.data.userScheduleList
      // 完成率
      this.tableDataByPerson.forEach(item => {
        item.rate = ((Number(item.completed) / Number(item.sum)) * 100).toFixed(2).toString() + '%'
      })
      this.setLineData(res.data.userScheduleList)
      this.setPieData(res.data.devSchedule, res.data.testSchedule)
    },
    // 根据不同项目状态进行分类
    setDiffData(list) {
      this.listData = {
        unCode: [],
        coding: [],
        codeFinish: [],
        // unTest: [],
        testing: [],
        testFinish: []
      }
      list.forEach(item => {
        // 根据不同状态放入不同数组中
        switch (item.caseStatus) {
          case '待开发':
            this.listData['unCode'].push(item)
            break
          case '开发中':
            this.listData['coding'].push(item)
            break
          case '开发完成':
            // case '待测试':
            this.listData['codeFinish'].push(item)
            // this.listData['unTest'].push(item)
            break
          case '测试中':
            this.listData['testing'].push(item)
            break
          case '测试完成':
            this.listData['testFinish'].push(item)
            break
        }
      })
    },
    /**
     * 构造统计用的数据
     * @param {Array} devData 开发进度
     * @param {Array} testData 测试进度
     */
    setPieData(devData, testData) {
      this.$refs.pieLeft.devData = devData
      this.$refs.pieRight.testData = testData
    },
    // 重置数据
    resetChartData() {
      this.devPieData = {}
      this.testPieData = {}
    },
    setLineData(lineData) {
      let nameData = []
      let valueData = []
      let backData = []
      lineData.forEach(t => {
        nameData.push(t.name)
        valueData.push(t.completed)
        backData.push(t.sum)
      })

      this.$refs.lineChart.nameData = nameData
      this.$refs.lineChart.valueData = valueData
      this.$refs.lineChart.backData = backData
    },
    initButtons() {
      this.buttonVisible = {
        save: !!this.specialAuthority.super, // 保存按钮是否显示
        // lock: !!this.specialAuthority.super, // 锁定按钮是否显示
        // unlock: !!this.specialAuthority.super, // 解锁按钮是否显示
        add: false, // 新增按钮是否显示
        update: false, // 编辑按钮是否显示
        delete: false, // 删除按钮是否显示
        refresh: true,
        sort: false, // 排序按钮是否显示
        search: false, // 查找按钮是否显示
        more: false // 更多按钮是否显示
      }

      this.moreButtonList = [
        {
          icon: 'iconfont fjyk-daoru-03-copy',
          name: '导入',
          event: 'import',
          visible: !!this.specialAuthority.super,
          disabled: !this.Authority.edit || !this.specialAuthority.super
        },
        {
          icon: 'iconfont fjyk-daochu-03-copy',
          name: '导出',
          event: 'export',
          disabled: !this.Authority.edit
        }
      ]
    },
    // 获取侧边栏数据（产品版本）
    async getNavList() {
      if (!this.Authority.see) {
        this.$message.warning('您没有查看权限!')
        return
      }
      this.settingsList = []
      // sqlTitle=all 可以查所有的产品类型；传具体产品类型可以过滤
      const { data: res } = await this.$http.post(`/Common/ProductVersionSet/list?sqlTitle=${this.curProductType}`)
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
      }
      res.data.forEach(item => {
        const temp = {
          name: item.productionVersion,
          type: item.productionType
        }
        this.settingsList.push(temp)
      })
      // 设置宏任务，在DOM渲染完成后执行，避免读取不到 navList DOM
      setTimeout(() => {
        if (res.data.length > 0) {
          // 默认切换到第一个产品版本
          // this.$refs.navList.setDefaultActiveIndex()
          this.indexValue = this.settingsList[0]?.name
          this.curSelectVersion = this.settingsList[0]?.name
          // 版本赋值后才请求数据
          this.refresh()
        }
      }, 0)
    },
    save() {
      this.httpUpdate()
    },
    // 发起修改请求
    async httpUpdate() {
      let tableData = [...this.tableDataSchedule]
      let insertRecords = this.$refs.xTable.getInsertRecords()
      let removeRecords = this.$refs.xTable.getRemoveRecords()
      let updateRecords = this.$refs.xTable.getUpdateRecords()
      tableData = []
      for (let item of insertRecords) {
        tableData.push(item)
      }
      for (let item of removeRecords) {
        item.id = item.id > 0 ? 0 - item.id : item.id
        tableData.push(item)
      }
      for (let item of updateRecords) {
        tableData.push(item)
      }
      tableData = this.removeArrayNull(tableData)
      // 赋值产品类型和产品版本
      tableData.forEach(item => {
        item.productionVersion = this.curSelectVersion
        item.menuArgs = this.curProductType
      })
      const { data: res } = await this.$http.post('/Common/YKProjectSchedule/save', tableData)
      if (res.isSuccess) {
        this.$message.success(this.messageConfig.save.success)
        // this.IfExistModify = false
        this.refresh()
      } else {
        this.$message.error(res.errorMessage)
      }
    },
    refresh() {
      this.getList()
      this.getStatisticList()
    },
    // 切换
    changeNavItem(item) {
      if (item.name === this.curSelectVersion) {
        return
      }
      this.indexValue = item.name
      this.curSelectVersion = item.name
      this.$nextTick(() => {
        this.refresh()
      })
    },
    // 切换产品类型
    changeSelect(type) {
      // 注意！每次切换必须缓存产品类型值，才能在保存和activated触发时取到当前选择的类型
      this.optionsValue = type
      this.$store.commit('set_productType', this.optionsValue)
      this.$nextTick(async () => {
        // 需要等版本获取到后，才能获取当前数据
        await this.getNavList()
        // this.getList()
      })
    },
    contextMenuClickEvent({ row, column, menu }) {
      // 打开工作量互评弹窗（目前只能操作当前点击的单元格，不能批量行操作）
      if (menu.code === 'schedule' && this.isCanShowSchedule(row, column)) {
        this.openScheduleModal(row, column)
        return
      }
      if (menu.code === 'choosePerson') {
        const colName = column.property
        // 提出人、前端研发、后端研发、技术测试、业务测试需要按岗位来过滤
        this.personSqlTitle = `post:${this.perSqlTitleMap[colName]}`

        // 当前点击的列名
        this.curSelectCol = colName
        this.areas = this.$refs.xTable.getCellAreas()
        this.openEmployeeSelect()
      }
      if (menu.code === 'batchDelete') {
        this.areas = this.$refs.xTable.getCellAreas()
        this.areas.forEach(area => {
          for (const col of area.cols) {
            for (const row of area.rows) {
              if (col.property === 'delete') {
                this.$refs.xTable.remove(row)
              }
            }
          }
        })
      }
    },
    // 是否能进行进度操作（特殊权限也需要控制，否则问题状态会乱）
    isCanShowSchedule(row, column) {
      // 能操作的条件：
      // 1.研发可填写条件：项目状态为[待开发、开发中、开发完成]
      // 2.测试可填写条件：项目状态为[开发完成、待测试、测试中、测试完成]

      let res = false
      // 标记当前状态 [研发|测试]
      let flag = ''
      const colName = column.property
      const curStatus = row['caseStatus']

      switch (colName) {
        case 'frontWorkPercentage':
        case 'backWorkPercentage':
          {
            res = ['待开发', '开发中', '开发完成'].includes(curStatus)
            flag = '研发'
          }
          break
        case 'techTestPercentage':
        case 'businessTestPercentage':
          {
            res = ['开发完成', '待测试', '测试中', '测试完成'].includes(curStatus)
            flag = '测试'
          }
          break
      }
      if (!res) {
        this.$message.warning(`当前状态不能修改${flag}进度`)
      }
      return res
    },
    visibleMethod({ row, options, column }) {
      options.forEach(allRightMenuList => {
        allRightMenuList.forEach(menuItem => {
          if (!column || !this.Authority.edit) {
            // 隐藏右键菜单：1.点击非表格的地方 2.无编辑权限
            menuItem.visible = false
          } else {
            switch (menuItem.code) {
              case 'schedule': {
                const col = [
                  'frontWorkPercentage',
                  'backWorkPercentage',
                  'techTestPercentage',
                  'businessTestPercentage'
                ]
                // 能显示条件：1.对应的进度为本人可填 || 2.有超级权限且当前点击列为[进度]
                if (this.specialAuthority.super && col.includes(column.property)) {
                  menuItem.visible = true
                  break
                }
                // 无超级权限，则校验是否本人
                const isShowMenu = this.isOwn(row, column)
                menuItem.visible = isShowMenu
                break
              }

              // 选择人员
              case 'choosePerson': {
                let personCol = ['frontEngineer', 'backEngineer', 'techTester', 'businessTester']
                // 能显示条件：1.有特殊权限 2.列对应得上
                menuItem.visible = !!(this.specialAuthority.super && personCol.includes(column.property))
                break
              }

              // 批量删除
              case 'batchDelete': {
                menuItem.visible = !!this.specialAuthority.super && column.property === 'delete'
                break
              }
            }
          }
        })
      })
      return true
    },
    /**
     * 判断权限：是否为本人
     * @param {Object} row 行数据
     * @param {String} column 当前点击的列数据
     */
    isOwn(row, column) {
      // 当前点击列名
      const colName = column.property
      // 对应的解决日期单元格，需对应的列为本人才可操作，字典如下：
      const authorityMap = {
        // [前端进度]：[前端研发]
        frontWorkPercentage: 'frontEngineer',
        // [后端进度]：[后端研发]
        backWorkPercentage: 'backEngineer',
        // [技术测试进度]：[技术测试]
        techTestPercentage: 'techTester',
        // [业务测试进度]：[业务测试]
        businessTestPercentage: 'businessTester'
      }
      // 当前列名对应的需检测的列
      const matchColName = authorityMap[colName]
      const res = row[matchColName] === this.curUserName

      return res
    },
    tableCellStyle({ row, column }) {
      if (row[column.property] === 100) {
        return {
          // backgroundColor: '#6bb2a0',
          backgroundColor: '#cde0c9',
          // color: '#fff'
          color: '#2c6975'
        }
      }
      return []
    },
    // 导入
    import() {
      if (!this.specialAuthority.super) {
        this.$message.warning('您没有相关操作权限')
        return false
      }

      this.$refs.Import.isShow = !this.$refs.Import.isShow
    },
    // 返回导入值 | 明细主信息
    sureImportBack(selectRecords) {
      if (selectRecords.length > 0) {
        this.$refs.xTable.insertAt(selectRecords, -1)
      }
    },
    // 导出
    export() {
      if (this.tabActiveName === 'first') {
        // 导出进度总览表
        this.$refs.xTable.exportData({
          type: 'xlsx',
          columnFilterMethod({ column }) {
            return !['checkbox', 'seq'].includes(column.type) && column.property !== 'delete'
          }
        })
      } else if (this.tabActiveName === 'third') {
        // 导出进度统计表
        this.$refs.xTableByPerson.exportData({
          type: 'xlsx',
          columnFilterMethod({ column }) {
            return !['checkbox', 'seq'].includes(column.type) && column.property !== 'delete'
          }
        })
      }
    },
    // 打开进度填写评估弹窗
    openScheduleModal(row, column) {
      // 当前人员类型
      const type = this.PERSONTYPE[column.property]
      // 当前数值
      const value = row[column.property]
      const rowID = row.id

      this.$refs.ScheduleSet.formVisible = true
      this.setSchedule(rowID, type, value)
    },
    // surebackSchedule (num) {
    //   console.log('数值', num)
    // },
    // 进度弹窗设置 rowID
    setSchedule(rowID, type, value) {
      this.$refs.ScheduleSet.rowID = rowID
      this.$refs.ScheduleSet.type = type
      this.$refs.ScheduleSet.num = value
    },
    // 格式化进度
    formatSchedule(row, column) {
      const n = row[column.property] >> 0
      return n + '%'
    },
    // 打开员工选择框
    openEmployeeSelect() {
      this.$refs.EmployeeSelect.formVisible = true
    },
    // 员工选择框返回值
    sureBackPerson(selectRecords) {
      // selectRecords: {
      //   id
      //   num // 用户名
      //   name // 姓名
      //   post // 岗位
      // }
      this.areas.forEach(area => {
        for (let row of area.rows) {
          row[this.curSelectCol] = selectRecords.name
        }
      })
    }
  },
  computed: {
    leftTableHeight() {
      let isSearchForm = this.searchFormVisible
      // 若有查询框，则共有四段 margin; 否则只有表格的两段 margin
      let tableMargin = isSearchForm ? this.heightConfig.mainMargin * 4 : this.heightConfig.mainMargin * 2
      let isToolBar = true
      return this.tableHeightComputed(tableMargin + this.topBottomMargin, isSearchForm, isToolBar)
    },
    // 进度表高度
    tableHeight() {
      if (this.tabActiveName === 'first') {
        let isSearchForm = this.searchFormVisible
        // 若有查询框，则共有四段 margin; 否则只有表格的两段 margin
        let tableMargin = isSearchForm ? this.heightConfig.mainMargin * 4 : this.heightConfig.mainMargin * 2
        let isToolBar = true
        // 选项卡高度(自身高度+margin = 30 + 10 = 40px)
        const tabsHeight = 40
        return this.tableHeightComputed(tableMargin + this.topBottomMargin + tabsHeight, isSearchForm, isToolBar)
      } else {
        return '100px'
      }
    },
    // 汇总表高度
    tableHeightByPerson() {
      if (this.tabActiveName === 'third') {
        let isSearchForm = this.searchFormVisible
        // 若有查询框，则共有四段 margin; 否则只有表格的两段 margin
        let tableMargin = isSearchForm ? this.heightConfig.mainMargin * 4 : this.heightConfig.mainMargin * 2
        let isToolBar = true
        // 选项卡高度(自身高度+margin = 30 + 10 = 40px)
        const tabsHeight = 40
        return this.tableHeightComputed(tableMargin + this.topBottomMargin + tabsHeight, isSearchForm, isToolBar)
      } else {
        return '100px'
      }
    },
    secondDvHeight() {
      let isSearchForm = this.searchFormVisible
      // 若有查询框，则共有四段 margin; 否则只有表格的两段 margin
      let tableMargin = isSearchForm ? this.heightConfig.mainMargin * 4 : this.heightConfig.mainMargin * 2
      let isToolBar = true
      // 选项卡高度(自身高度+margin = 30 + 15 = 40px)
      const tabsHeight = 40
      return this.tableHeightComputed(tableMargin + this.topBottomMargin + tabsHeight, isSearchForm, isToolBar)
    },
    // 设置表格容器的高度
    settingsCardHeight() {
      return this.leftTableHeight + this.topBottomMargin
    },
    // 当前选中的产品类型
    curProductType() {
      return this.$store.state.productType
    },
    // 当前登录用户名
    curUserName() {
      return this.$store.state.userInfo.userName
    }
  }
}
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  margin: 0 auto;
  height: calc(100vh - @header-height);
  overflow: hidden;
}
.card {
  margin: @main-margin;
  box-shadow: #bebebe 2px 2px 10px;
  border-radius: 10px;
  overflow: hidden;
}
.search-dv {
  background-color: aquamarine;
  height: 100px;
  margin: @main-margin 10px;
}

.toolbar-dv {
  padding: 10px;
}

.table-dv {
  padding: @topBottomMargin;
}

.settings-table-dv {
  box-sizing: border-box;
  padding: 10px;
  width: 100%;
}
// 左侧名称列表
.left-settings-dv {
  width: 100%;
}
.settings-list-dv {
  width: 100%;
  border-radius: 5px;
  box-shadow: #e2e2e2 0px 0px 3px;
  border: 1px solid #eeeeee;
  overflow: hidden;
  position: relative;
}

// 用户名列表
.right-user-dv {
  width: 100%;
}

// 看板
.second-dv {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 3px 0;
  display: grid;
  column-gap: 20px;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
}

.third-dv {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: grid;
  column-gap: 20px;
  grid-template-columns: 1fr 1fr;
  overflow-y: auto;

  .third-left-dv {
    height: 100%;
    display: grid;
    row-gap: 20px;
    grid-template-rows: 1fr 1fr;

    // 饼图
    .pie-dv {
      width: 100%;
      // background-color: cadetblue;
      display: grid;
      grid-template-columns: 1fr 1fr;
      column-gap: 20px;

      > div {
        .fl();
        border-radius: 10px;
      }
    }
    .line-dv {
      width: 100%;
      .fl();
    }
  }

  .third-right-dv {
    height: 100%;
  }
}

/* el-tabs 样式 */
/deep/ .el-tabs__item {
  height: 30px;
  line-height: 22px;
}
/deep/ .el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0 0 15px;
}
/deep/ .el-tabs__item.is-top {
  font-size: 16px;
}
</style>
